import { ClinicOnlineBookingSetup } from 'app/shared/portal/models/clinic-online-booking-setup.model';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { generalAnimations } from 'app/shared/animations/animations';
import { AppointmentNotificationType } from 'app/shared/appointments/models/appointment-notification-type.enum';
import { Clinic } from 'app/shared/clinics/models/clinic.model';
import { Subscription } from 'rxjs';
import { ClientPortalAuthorizedLoginProviderByFranchise } from '../../models/client-portal-authorized-login-provider-by-franchise.model';
import { SysLoginProvider } from '../../models/sys-login-provider.model';
import { AuthService } from '../../services/auth.service';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LoginType } from '../../models/login-type.model';
import { LoginTypeEnum } from '../../models/login-type.enum';

@Component({
  selector: 'core-auth-login-selection',
  templateUrl: './login-selection.component.html',
  styleUrls: ['./login-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: generalAnimations,
  standalone: false,
})
export class LoginSelectionComponent implements OnInit, OnDestroy {
  @Input() loginType!: LoginType;
  @Output() oneTimeLoginEmailEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() oneTimeLoginSmsEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() emailConfirmationEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() setLoginTypeEmitter: EventEmitter<LoginType> = new EventEmitter<LoginType>();
  @Output() closeModalEmitter: EventEmitter<any> = new EventEmitter<any>();
  clinic: Clinic = JSON.parse(localStorage.getItem('clinic') || '{}');
  canSendSms = false;
  isSubmitted = false;

  sysLoginProviders: SysLoginProvider[] = [];
  franchiseProviders?: ClientPortalAuthorizedLoginProviderByFranchise[] = [];
  portalSetup?: ClinicOnlineBookingSetup;

  loginFormGroup = new UntypedFormGroup({
    value: new UntypedFormControl(null, [Validators.required]),
  });

  private subscription: Subscription = new Subscription();
  constructor(
    // private clinicService: ClinicHttpService,
    private authService: AuthService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loginFormGroup.get('value')?.setValue(this.loginType.value);
    const notifTypes = [
      {
        clinicGroupId: 0,
        isDefault: true,
        sysAppointmentNotificationTypeId: 1,
        sysAppointmentNotificationType: {
          isOptional: true,
          id: 1,
          nameEn: 'Email',
          nameFr: 'Courriel',
          nameEs: 'Email',
          nameDe: 'Email',
          name: 'Email',
        },
      },
      {
        clinicGroupId: 0,
        isDefault: false,
        sysAppointmentNotificationTypeId: 2,
        sysAppointmentNotificationType: {
          isOptional: true,
          id: 2,
          nameEn: 'SMS',
          nameFr: 'SMS',
          nameEs: 'SMS',
          nameDe: 'SMS',
          name: 'SMS',
        },
      },
      {
        clinicGroupId: 0,
        isDefault: false,
        sysAppointmentNotificationTypeId: 3,
        sysAppointmentNotificationType: {
          isOptional: true,
          id: 3,
          nameEn: 'Digital Phone Call',
          nameFr: 'Appel téléphonique digital',
          nameEs: 'Digital Phone Call',
          nameDe: 'Digital Phone Call',
          name: 'Digital Phone Call',
        },
      },
      {
        clinicGroupId: 0,
        isDefault: false,
        sysAppointmentNotificationTypeId: 5,
        sysAppointmentNotificationType: {
          isOptional: false,
          id: 5,
          nameEn: 'Do Not Send Appointment Reminders',
          nameFr: 'Aucun rappel de rendez-vous',
          nameEs: 'Do Not Send Appointment Reminders',
          nameDe: 'Do Not Send Appointment Reminders',
          name: 'Do Not Send Appointment Reminders',
        },
      },
    ];
    this.canSendSms =
      notifTypes.findIndex(
        notif => notif.sysAppointmentNotificationType.id === AppointmentNotificationType.SMS
      ) >= 0;
    // this.subscription.add(
    //   this.clinicService
    //     .getClinicFranchiseSupportedNotificationTypes()
    //     .subscribe(notificationTypes => {
    //       this.canSendSms =
    //         notificationTypes.findIndex(
    //           notif => notif.sysAppointmentNotificationType.id === AppointmentNotificationType.SMS
    //         ) >= 0;
    //       this.ref.markForCheck();
    //     })
    // );
    const portalSetupJson = localStorage.getItem('portalSetup');
    if (portalSetupJson) {
      const portalSetup = JSON.parse(portalSetupJson);
      this.portalSetup = portalSetup;
      this.franchiseProviders = portalSetup?.clientPortalAuthorizedLoginProviderByFranchise;
    }
    // this.getSysLoginProviders();
  }

  onSelectEmail(): void {
    this.oneTimeLoginEmailEmitter.emit();
  }

  onSelectSms(): void {
    this.oneTimeLoginSmsEmitter.emit();
  }

  onSwitchToEmailConfirmation(): void {
    this.emailConfirmationEmitter.emit();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  // getSysLoginProviders(): void {
  //   this.subscription.add(
  //     this.authService.getSysLoginProviders().subscribe(sysProviders => {
  //       if (sysProviders && this.franchiseProviders) {
  //         this.franchiseProviders.forEach(franProv => {
  //           const providerDetail = sysProviders.find(
  //             sysProv => sysProv.id === franProv.sysLoginProviderId
  //           );
  //           if (providerDetail) {
  //             this.sysLoginProviders.push(providerDetail);
  //           }
  //         });
  //         this.ref.markForCheck();
  //       }
  //     })
  //   );
  // }

  // socialLogin(sysLoginProvider: SysLoginProvider): void {
  //   if (sysLoginProvider.id === LoginProvider.Twitter) {
  //     this.authService.twitterLogin(sysLoginProvider, OauthEventType.Login);
  //   } else {
  //     this.authService.socialLogin(sysLoginProvider, window.location.origin, OauthEventType.Login);
  //   }
  // }

  onValueSubmit(): void {
    this.isSubmitted = true;
    if (this.loginFormGroup.valid) {
      this.subscription.add(
        this.authService.loginType(this.loginFormGroup.get('value')?.value).subscribe(matches => {
          const loginType: LoginType = {
            isUsername: !!matches.find(id => id === LoginTypeEnum.UserName),
            isSms: false, // To Block 1 time access workflow
            isEmail: false, // To Block 1 time access workflow
            value: this.loginFormGroup.get('value')?.value,
          };
          this.setLoginTypeEmitter.emit(loginType);
        })
      );
    }
    this.ref.markForCheck();
  }

  displayRequiredError(control: AbstractControl): boolean {
    return control.hasError('required') && (control.touched || this.isSubmitted);
  }
}
